import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
    templateUrl: 'checkbox.component.html',
    selector: 'checkbox-component',
    styleUrls: ['checkbox.less']
})

export class CheckboxComponent {

    @Input() possibleValues;

    @Input() selectedValues;

    @Input() shownProperty = 'name';

    @Input() modelName;

    @Input() columns;

    @Input() disabled = false;

    @Output() updateEmitter = new EventEmitter();

      private parseToDashCase(string) {
      // http://stackoverflow.com/questions/1983648/replace-space-with-dash-and-make-all-letters-lower-case-using-javascript
      return string.replace(/\s+/g, '-').toLowerCase();
    }

    private isChecked(valueToCheck) {
      if (!this.selectedValues) {
        return false;
      }

      for (let selectedValue of this.selectedValues) {
        if (selectedValue.id === valueToCheck.id ) {
          return true;
        }
      }
    }


  private changeHandler($event, item) {
    if ($event.target.checked === true) {
      this.selectedValues.push(item);
    } else {
      if (this.selectedValues.length) {
          for (let i = 0; i < this.selectedValues.length; i++) {
              if (this.selectedValues[i].id === item.id) {
                  this.selectedValues.splice(i, 1);
                  break;
              }
          }
      }
    }

    const outputObj = {
      event: $event,
      updatedData: this.selectedValues,
      model: this.modelName
    };

    this.updateEmitter.emit(outputObj);
  }
}



// WEBPACK FOOTER //
// ./src/app/_component/checkbox/checkbox.component.ts